import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { state } from '@/store/consultories/state'
import { mutations } from '@/store/consultories/mutations'
import { actions } from '@/store/consultories/actions'
import { getters } from '@/store/consultories/getters'
import { ConsultoryState } from '@/store/consultories/types'

export const consultories: Module<ConsultoryState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
